import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getWizardOverview } from 'api/Wizard/Wizard';

export const useGetWizardOverview = ({ params = {}, options = {}, dependencies = [] }) => {
  const navigate = useNavigate();
  return useQuery(
    [
      `wizard-overview`,
      params?.practice_id ?? params?.practiceId,
      params?.overview_group_code,
      ...dependencies
    ],
    () => getWizardOverview(navigate, params),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      ...options
    }
  );
};
